import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, AfterViewInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-cancelleavepopup',
  templateUrl: './cancelleavepopup.component.html',
  styleUrls: ['./cancelleavepopup.component.css']
})
export class CancelleavepopupComponent implements OnInit {

  dateCustomClasses: DatepickerDateCustomClasses[];
  
  constructor(private toastr: ToastrService, private appService: AppdataService,
    private loginService: LoginserviceService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService,
    private datePipe: DatePipe,private productFindService: NgbModal) {
      this.dateCustomClasses = [
        { date: new Date(), classes: ['bg-warning'] },
      ];
     }

   
  //Save Validation
  submitted: boolean;
  successfully: boolean;
 
  isduplicate: boolean;

  

  leavecancelform = new FormGroup({
   
    leaveid: new FormControl(0),
    iscancelled: new FormControl(false),
    cancelleddesc: new FormControl('', Validators.required),
  
    
  });

  transpaymodeColl: any = [];

  
  @Input() leaveid:any=0;
  @Input() iscancelled: any= false;
  @Input() cancelleddesc: any = '';

  
  @Output() emitData = new EventEmitter();

  ngOnInit() {

    this.leavecancelform.reset();
    this.fnInitializeFormGroup();
  }


  fnInitializeFormGroup() {
    this.leavecancelform.setValue({
      leaveid: this.leaveid,
      iscancelled: this.iscancelled,
      cancelleddesc: this.cancelleddesc,      
    })
  }

  fnSaveBtnClick() {
    try {
      this.submitted = true;
      this.successfully = false;

    

      //Validate
      if (this.leavecancelform.valid) {

        

        //Check
        var data = {
          leaveid:this.leaveid,
      
          iscancelled: true,
          cancelleddesc: this.leavecancelform.get('cancelleddesc').value,
          cancelledby: this.loginService.fnGetModUserId(),
         // cancelledon:this.loginService.fnGetModUserId(),   
        }
      this.appService.fnSetLeaveCancel(data).subscribe(
        (res)=>{ 
          if(res.json().status===200){  
            this.emitData.emit('DONE');
            this.activeModal.close(true);
            }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err)=>{ 
          this.toastr.error('Error', err);
        });
      }
    }
     catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

    // //AddTransPaymode
    // private fnAddTransPaymode() {

    //   const modalRef = this.productFindService.open(LeavecancelpopupComponent, { size: <any>'l' });
  
    //   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
    //     this.fngetTranspaymode();
  
    //     if (receivedEntry > 0) {
    //       this.transpaymentinfoform.patchValue({ transpaymodeid: receivedEntry })
    //     }
    //   });
  
    // }
  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }
  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }

}
